export const FORM_FIELDS = {
  NOTE_CONTENT: 'noteContent',
} as const

export const FORM_DEFAULTS = {
  [FORM_FIELDS.NOTE_CONTENT]: '',
} as const

export const PLACEHOLDERS = {
  NOTE_CONTENT: 'Add your note content here...',
} as const

export const MOCK_NOTE_MESSAGES = [
  'Client expressed interest in personal training sessions. Follow up next week to discuss package options.',
  'Great progress on fitness goals! Client has lost 5 pounds since starting and is very motivated.',
  'Client had some concerns about knee pain during squats. Recommended alternative exercises and suggested consulting with a physiotherapist.',
  'Completed fitness assessment. Client shows good cardiovascular health but needs to work on flexibility.',
  'Client is traveling for business next month. Discussed maintaining routine with hotel gym workouts.',
  'Renewed membership for another year. Client is very satisfied with the facility and staff support.',
  'Client requested nutrition consultation. Scheduled appointment with our nutritionist for next Thursday.',
  'Participated in group fitness class for the first time. Really enjoyed it and wants to make it a regular part of routine.',
  'Client reported some scheduling conflicts with current training times. Adjusted to morning sessions.',
  'Achieved personal record on bench press today! Client is thrilled with the progress made over the past 3 months.',
] as const

export const LOADING_SPINNER_SIZE = 16
export const DATE_FORMAT = 'MMM d, yyyy'
export const RICH_EDITOR_HEIGHT = 200
export const NOTE_CONTENT_MAX_HEIGHT = 600
export const PENCIL_ICON_SIZE = 16

export type FormField = (typeof FORM_FIELDS)[keyof typeof FORM_FIELDS]
